<div id="nav-page-grid-controls">
  <div class="left-align-option" *ngIf="defaultFiltersSet && !metaError">
    <div class="grid-control">
      <app-data-revisions-dropdown
        [singleSelect]="true"
        [noYoy]="true"
        [showReset]="false"
        [dataView]="dataView"
        (saveDataView)="updateDataView($event)"
      ></app-data-revisions-dropdown>
    </div>
    <div class="grid-control currency-filter" style="width: 78px">
      <va-currency-select
        size="small"
        selectWidth="78"
        labelPlacement="top"
        [bottomBorderView]="true"
        [(selectedCurrency)]="selectedCurrency"
        [disabled]="currencyDisabled"
        [apiEP]="apiEP"
        apiUrl="/api/get_available_currencies"
        (onChange)="onCurrencyChange($event)"
      >
      </va-currency-select>
    </div>
    <div
      class="grid-control custom-consensus-filter"
      *ngIf="metaInfo.sources_info && metaInfo.sources_info.length > 0"
    >
      <va-multi-select-dropdown
        [data]="customSourcesDropdown"
        showApplyButton="true"
        (callback)="customConsensusChange($event)"
      ></va-multi-select-dropdown>
    </div>
  </div>
  <div class="right-align-option" *ngIf="defaultFiltersSet && !metaError">
    <div class="grid-control">
      <div class="high-low-toggle">
        <span class="toggle-text">Highlight High/Low</span>
        <nz-switch
          nzSize="small"
          [ngModel]="showHighLow"
          (ngModelChange)="onHighLowSwitchChange($event)"
        ></nz-switch>
      </div>
    </div>
    <div class="grid-control">
      <app-export-to-excel-dropdown
        class="export-button"
        [(isPopoverVisible)]="isExportPopoverVisible"
        [disabled]="!metaInfo"
        [optionList]="excelToExportDropdownOptions"
        [isExportInProgress]="isExportInProgress"
        (onListItemClick)="handleETEListItemClick($event)"
      ></app-export-to-excel-dropdown>
    </div>
  </div>
  <div *ngIf="!defaultFiltersSet">
    <nz-skeleton
      [nzTitle]="true"
      [nzActive]="true"
      [nzParagraph]="false"
    ></nz-skeleton>
  </div>
</div>

<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faCheck"
      class="snack-icon snack-success-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faTimesCircle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon
      isFontAwesome="true"
      [name]="faInfoCircle"
      class="snack-icon snack-info-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon isFontAwesome="true" [name]="faTimes"></va-icon>
    </span>
  </div>
</ng-template>
